// 榜单列表页
import { ContentType } from "@/api/scode/scode_params";
import loadingPng from "@/base64";
import PosterSwipePro from "@/components/poster-swiper/pro";
import { platform } from "@/utils/platform";
import { pxtorem } from "@/utils/pxtorem";
import AKJS from "@akc/akjs";
import { Image } from "antd-mobile";
import React, { useEffect, useRef, useState } from "react";
import customStyles from "./components/CustomTopBack.module.less";
// import EmptyShowTipView from "./components/EmptyShowTipView";
import EmptyView from "./components/EmptyView";
import LeftTopBtnBox from "./components/LeftTopBtnBox";
import RankBottomListView from "./components/RankBottomListView";
import SingleRankDetailCard from "./components/SingleRankDetailCard";
import TopBgBox from "./components/topBgBox";
import TwoLevelTab from "./components/TwoLevelTab";
import { useAppStatusBarHeight } from "./hooks/useAppStatusBarHeight";
import { useRankAll } from "./hooks/useRankAll";
import { useRankListShare } from "./hooks/useRankListShare";
import { useRankShare } from "./hooks/useRankShare";
import { useRankSystemShare } from "./hooks/useRankSystemShare";
import styles from "./RankAll.module.less";

/**
 * 全部榜单
 * 页面url参数searchParam有：
 * categoryOneId: 一级类目ID
 * page_name: 页面名称
 * previous_page_name: 上一个页面名称
 * shopId: 店铺ID
 */

const RankAll: React.FC = () => {
  const control = useRankAll();
  const {
    rankDataList,
    singleRankPrdList,
    isSingleRank,
    getRankDataList,
    fetchSingleRankProducts,
    hasMore,
    containerDom,
    onShowTabPop,
    level1Opts,
    skin,
    showTabPop,
    goToRankScale,
    selectedFirstIndex,
    activeLevel1Tab,
    selectedSecondIndex,
    activeLevel2Tab,
    onFirstTabClick,
    onSecondTabClick,
    track,
    searchParam,
    loading,
    showEmptyShowTip,
    commonContext,
    initEnd,
  } = control;

  // 添加吸顶效果相关状态
  const [isTabSticky, setIsTabSticky] = useState(false);
  // 使用榜单分享Hook

  const { swiperControl } = useRankListShare({
    rankShare: {
      contentType: ContentType.rankCenter,
      oneCategoryId: activeLevel1Tab?.categoryId || "",
      contentId: activeLevel2Tab?.tabCode || "",
      // title: activeLevel2Tab?.tabName || "热卖榜单",
      // marketName: "榜单中心",
    },
  });

  // 单榜单分享单独调用一次hook,生成一套配置
  const {
    productControl,
    handleShareProduct,
  } = useRankShare({
    rankShare: {
      contentType: ContentType.categoryRank,
      contentId: activeLevel1Tab?.singleRankNo || "",
      marketName: "单榜单详情",
    },
  });


  // 系统分享配置;
  useRankSystemShare({
    rankShare: {
      contentType: ContentType.rankCenter,
      oneCategoryId: activeLevel1Tab?.categoryId || "",
      contentId: activeLevel2Tab?.tabCode || "",
      title: activeLevel2Tab?.tabName || "热卖榜单",
      shareType: "HOT_LIST_TOTAL",
      posterCode: "TotalHotListPoster",
      pageName: "榜单中心",
    },
  });

  const statusBarHeight = useAppStatusBarHeight();
  // console.log("statusBarHeight", statusBarHeight);

  // 点击页面底部的分享按钮
  const clickShareMontyBtn = () => {
    if (track.track) {
      track.track("btn_click", {
        page_name: "榜单中心",
        tab_name: activeLevel1Tab?.categoryName,
        tab_id: activeLevel1Tab?.categoryId,
        previous_page_name: searchParam.get("page_name"),
        btn_name: commonContext.currentRole === "C" ? "分享榜单" : "转发赚钱",
        btn_text: commonContext.currentRole === "C" ? "分享榜单" : "转发赚钱",
      });
    }

    swiperControl.open({
      bizInfo: {
        contentId: activeLevel2Tab?.tabCode || "",
        contentExtra: {
          oneCategoryId: activeLevel1Tab?.categoryId || "",
          posterCode: "TotalHotListPoster",
        },
      },
      envContext: {
        sourceSceneId: activeLevel2Tab?.tabCode || "",
      },
      contentContext: {
        contentExtra: {
          oneCategoryId: activeLevel1Tab?.categoryId || "",
        },
      },
    });
    console.log("clickShareMontyBtn");
  };

  // 获取榜单列表Fragment
  const getRankListFragment = () => {
    // 单榜单组件
    if (isSingleRank) {
      return (
        <SingleRankDetailCard
          loading={loading}
          productList={singleRankPrdList || []}
          rankName={activeLevel1Tab?.singleRankName}
          rankNo={activeLevel1Tab?.singleRankNo}
          pageName="榜单列表"
          onLoadMore={() => fetchSingleRankProducts(activeLevel1Tab?.singleRankNo)}
          hasMore={hasMore}
          handleShareProduct={handleShareProduct}
        />
      );
    }
    // 榜单卡片列表
    return (
      <RankBottomListView
        data={rankDataList}
        loadMore={() => getRankDataList(selectedFirstIndex, selectedSecondIndex)}
        tabName={activeLevel1Tab?.categoryName}
        hasMore={hasMore}
        toRankDetailAction={(rankno, tsindex) => goToRankScale(rankno, tsindex)}
        type={1}
      />
    );
  };

  useEffect(() => {
    document.title = "热卖榜单";
    if (platform.isApp) {
      AKJS.ready().then(() => {
        AKJS.action
          .dispatch("event.navigationBar.hide", {
            hide: true,
          })
          .catch(error => {
            console.error("app设置顶部导航栏失败:", error);
          });
      });
    }
  }, []);

  // 连一级tabs都没查到
  if (initEnd.current && !level1Opts?.length) {
    return <EmptyView text={"当前榜单已过期失效～~"} />;
  }

  // 榜单分享海报弹窗组件的props，不同场景取不同的配置
  // 滚动容器的特殊class，分别控制不同的padding样式
  const scrollBoxClassName = isSingleRank ? styles.singleRankClass : (activeLevel1Tab.tabItemVOList?.length ? styles.showLevel2TabPadding : styles.showNoLevel2TabPadding);

  return (
    <div
      className={`${styles.pageContainer} ${platform.isH5 ? customStyles.container_with_top_back : ""}${platform.isiOS ? customStyles.noBounce : ""}`}>
      {/* 榜单分享海边弹窗 */}
      <PosterSwipePro {...swiperControl.props} />
      {/* 商品分享海边弹窗 */}
      <PosterSwipePro {...productControl.props} />

      {/* 空榜单列表的占位组件
      {
        showEmptyShowTip && <EmptyShowTipView />
      } */}
      {/* 左上角悬浮的按钮盒子 */}
      <LeftTopBtnBox isSticky={isTabSticky} statusBarHeight={statusBarHeight} />

      {/* 榜单头部内容组件（两侧枝条+中间榜单名称） */}
      <TopBgBox statusBarHeight={statusBarHeight} isTabSticky={isTabSticky} />

      {/* 榜单列表 */}
      <div
        className={styles.scrollable_content + " " + scrollBoxClassName}
        ref={containerDom}>
        {/* 二级tabs组件，传递 onStickyChange 回调 */}
        <div className={styles.TwoLevelTabBox}>
          <TwoLevelTab
            statusBarHeight={statusBarHeight}
            level1Opts={level1Opts}
            selectedFirstIndex={selectedFirstIndex}
            selectedSecondIndex={selectedSecondIndex}
            showTabPop={showTabPop}
            onFirstTabClick={onFirstTabClick}
            onSecondTabClick={onSecondTabClick}
            onShowTabPop={onShowTabPop}
            onStickyChange={setIsTabSticky}
            fixedStyle={{ background: "#fff" }}
          />
        </div>
        <div className={styles.rankListContentBox}>
          {/* 榜单列表组件 */}
          {getRankListFragment()}

          {/* Loading覆盖层 - 绝对定位在页面中心 */}
          {loading && (
            <div className={styles.loadingIcon}>
              <Image src={loadingPng} width={pxtorem(30)}></Image>
            </div>
          )}
        </div>
      </div>

      {level1Opts && level1Opts.length > 0 && (
        <div className={styles.bottomBtn} onClick={clickShareMontyBtn}>
          {commonContext.currentRole === "C" ? (
            <div className={styles.bottomBtnText}>分享榜单</div>
          ) : (
            <div className={styles.bottomBtnTextMoney}>转发赚钱</div>
          )}
        </div>
      )}

      {showTabPop && <div className={styles.bottomBtnBg}></div>}
    </div>
  );
};

export default RankAll;
